import React from 'react';
import { Image, Text } from 'react-native-web';
import FullPageSimulator from '../FullPageSimulator';
import {
  Android,
} from '../../../../utils/DictionaryManagementUtils';
import { getMediumFont } from '../../../../utils/Utils';
import { getImageByKey } from '../../../../utils/ImagesManagementUtils';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';

const Launch_error_messagesDF = ({
  globJSON,
  simPlatform,
  imageKey,
  imageSource,
  txtTitleStr,
  TopTitle,
  BtnInputText,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    titleStyle: {
      width: 190,
      paddingVertical: 15,
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 14,
      alignSelf: 'center',
      textAlign: 'center',
      color: colors.primary_font_color,
    },
    imageStyle: {
      width: 158,
      height: 90,
      alignSelf: 'center',
      marginBottom: simPlatform === Android ? 50 : 20,

    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
    >
      <Text style={myStyles.titleStyle}>
        {txtTitleStr}
      </Text>

      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imageStyle}
        source={getImageByKey(imageSource, imageKey)}
      />
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        inputText={BtnInputText}
      />
    </FullPageSimulator>
  );
};

export default Launch_error_messagesDF;
